import { EntityTableEmptyState } from "@repo/ui/tables/entityTableEmptyState";
import type { FC, ReactNode } from "react";

interface SettingsTableEmptyBodyContentProps {
  colSpan: number;
  children: ReactNode;
}

export const SettingsTableEmptyBodyContent: FC<
  SettingsTableEmptyBodyContentProps
> = ({ colSpan, children }) => (
  <tr>
    <td colSpan={colSpan}>
      <EntityTableEmptyState>{children}</EntityTableEmptyState>
    </td>
  </tr>
);
